module.exports = __webpack_public_path__ + "img/首图中文.af4441ae.png";